import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { AlmacenInsumosModule } from './almacen-insumos/almacen-insumos.module';
import { AlmacenMenajeriaModule } from './almacen-menajeria/almacen-menajeria.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AsignacionMenuModule } from './asignacion-menu/asignacion-menu.module';
import { CallbackComponent } from './auth/callback/callback.component';
import { CocinaModule } from './cocina/cocina.module';
import { CuadroPicnicModule } from './cuadro-picnic/cuadro-picnic.module';
import { HomeComponent } from './home/home.component';
import { ProveedoresModule } from './proveedores/proveedores.module';
import { ReportesModule } from './reportes/reportes.module';
import { AuthInterceptor } from './services/interceptors/auth.interceptor';
import { LoadingInterceptorService } from './services/interceptors/loading-interceptor.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HomeComponent,
    CallbackComponent,
    FormsModule,
    RouterModule,
    CocinaModule,
    MatListModule,
    MatIconModule,
    ReportesModule,
    MatButtonModule,
    AppRoutingModule,
    HttpClientModule,
    MatToolbarModule,
    MatDividerModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTooltipModule,
    ProveedoresModule,
    CuadroPicnicModule,
    ReactiveFormsModule,
    AlmacenInsumosModule,
    AsignacionMenuModule,
    AlmacenMenajeriaModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    TablerIconsModule.pick(TablerIcons),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
